import { OnResizeStart } from 'react-moveable'
import { IMediaItem } from 'types/media'
import { clampStrokeThickness } from 'utils/text'

const calculateScaling = (initialWidth: number, width: number) => {
  return width / initialWidth
}

const calcScaledValues = (
  initialFontSize: number,
  initialStrokeThickness: number,
  initialWidth: number,
  width: number
) => {
  const ratio = width / initialWidth
  return {
    fontSize: initialFontSize * ratio,
    strokeThickness: clampStrokeThickness(initialStrokeThickness * ratio)
  }
}

export const useTextSpecificActions = (item: IMediaItem) => {
  const isText = item.type === 'text'

  const handleResizeStart = ({ datas }: OnResizeStart) => {
    datas.initialWidth = item.width
    datas.initialFontSize = item.meta?.textData?.fontSize
    datas.initialStrokeThickness = item.meta?.textData?.strokeThickness ?? 0
  }

  const handleResize = (
    engineUpdate: Record<string, unknown>,
    datas: Record<string, number>,
    width: number
  ) => {
    if (datas.initialFontSize && datas.initialWidth) {
      const scaling = calculateScaling(datas.initialWidth, width)
      engineUpdate.width = item.width * scaling
      engineUpdate.height = item.height * scaling
    }
  }

  const handleResizeEnd = (
    updates: Partial<IMediaItem>,
    datas: Record<string, number>,
    width: number
  ) => {
    if (datas.initialFontSize && datas.initialWidth) {
      const { fontSize, strokeThickness } = calcScaledValues(
        datas.initialFontSize,
        datas.initialStrokeThickness,
        datas.initialWidth,
        width
      )
      updates.meta = {
        ...item.meta,
        textData: {
          ...item.meta.textData!,
          fontSize,
          strokeThickness
        }
      }
    }
  }

  return {
    handleTextResizeStart: handleResizeStart,
    handleTextResize: handleResize,
    handleTextResizeEnd: handleResizeEnd,
    isText
  }
}
